import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page__content" }

import { computed } from 'vue'
import type { Component } from 'vue'

// Store
import { useAuthModalStore, useCommonStore } from '@/store'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Modal from '@/components/ui/Modal'
import Registration from '@/components/Registration'
import Login from '@/components/Login'
import Video from '@/components/ui/Video'

// i18n
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const commonStore = useCommonStore()
const modalStore = useAuthModalStore()

// Components
const { t } = useI18n()

// Router
const route = useRoute()

// Computed
const isUserAuth = computed<boolean>(() => Boolean(commonStore.user))
const isComponent = computed<Component | void>(() => {
  switch (modalStore.component) {
    case 'Registration':
      return Registration
    case 'Login':
      return Login
  }
})

// Methods
function closeModal(): void {
  modalStore.toggleModal(false)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(commonStore).init)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["page", {'page_unAuth': !isUserAuth.value, 'page_loading': _unref(commonStore).loading}])
        }, [
          _createVNode(_unref(Header), { class: "page__header" }),
          _createElementVNode("main", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createVNode(_unref(Footer), { class: "page__footer" })
        ], 2))
      : _createCommentVNode("", true),
    (_unref(modalStore).show)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 1,
          onClose: closeModal,
          loading: _unref(modalStore).loading
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(isComponent.value)))
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Video))
  ], 64))
}
}

})